/**
 * Student ID  Reducers
 */
import {
    CONTRACT_STUDENT_ACTION,
    CONTRACT_ALL_STUDENT,
    DETAILS_ID_CARD,
    DOWNLOAD_STUDENT_CARD,
    UPLOAD_STUDENT_IMAGE
} from 'Actions/types';


const INIT_STATE = {
    contractstudentlist: [],
    studentidcardlist: [],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case CONTRACT_STUDENT_ACTION:
            return { ...state, loading: true };

        case CONTRACT_ALL_STUDENT:
            return { ...state, loading: false, contractstudentlist: action.payload };

        case DETAILS_ID_CARD:
            return { ...state, loading: false, studentidcardlist: action.payload };

        case DOWNLOAD_STUDENT_CARD:
            return { ...state, loading: false, };

        case UPLOAD_STUDENT_IMAGE:
            return { ...state, loading: false, };
        default: return { ...state };

    }
}